import { ModalProps } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ConnectWalletModalGuard, ModalLegacy } from "@looksrare/uikit";
import { AddCollectionToWatchlistModalBody } from "components/Modals/AddCollectionToWatchlistModal/AddCollectionToWatchlistModalBody";

interface AddCollectionToWatchlistModalProps {
  isOpen: boolean;
  onClose: ModalProps["onClose"];
}

export const AddCollectionToWatchlistModal = ({ isOpen, onClose }: AddCollectionToWatchlistModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalLegacy isOpen={isOpen} onClose={onClose} title={t("Add to Watchlist")} closeOnOverlayClick={false}>
      <ConnectWalletModalGuard>
        <AddCollectionToWatchlistModalBody onClose={onClose} />
      </ConnectWalletModalGuard>
    </ModalLegacy>
  );
};
